import axios from 'utils/axios-interceptor';
import { API_URL } from 'constants/config';
import ls from 'localstorage-slim';
// enable global encryption
ls.config.encrypt = true;

// get all questions
export const getApplicantList = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token') || payload?.token}`,
    organisationid: ls.get('orgId') || payload.orgId,
  };
  const query = {
    search: payload.search_keyword ? payload.search_keyword : '',
    sort: payload.sort,
    sortBy: payload.sortBy,
    currentPage: payload.currentPage,
    perPage: payload.perPage,
    type: payload?.type,
    program: payload?.program,
    showAll: payload?.showAll,
    gender: payload?.gender,
  };
  try {
    return await axios.get(`${API_URL}/admin/apprenticeship-program/registered-applicant-details/list`, { params: query, headers });
  } catch (err) {
    throw new Error(err);
  }
};

export const generateOTP = async (payload) => {
  const { orgId, applicantEmail } = payload;
  try {
    const id = orgId || ls.get('registration-orgId');
    return await axios.post(`${API_URL}/applicant-registration/generate-otp/${id}`, { applicantEmail }, {});
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const verifyOTP = async (payload) => {
  const { applicantEmail, otp, orgId } = payload;
  const id = orgId || ls.get('registration-orgId');
  try {
    // const headers = {
    //   headers: {
    //     organisationid: '64a39ad8d39a9dd5e37de0c1',
    //   },
    // };
    return await axios.post(`${API_URL}/applicant-registration/verify-otp/${id}`, { applicantEmail, otp }, {});
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const getApplicantDetails = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('registration-token') || payload?.token}`,
  };
  try {
    return await axios.get(`${API_URL}/applicant-registration/details`, { headers });
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const updateApplicantDetail = async (payload) => {
  // const { applicantEmail, otp } = payload;
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('registration-token') || payload?.token}`,
    };
    return await axios.post(`${API_URL}/applicant-registration/update`, payload, { headers });
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const submitApplicantDetail = async (payload) => {
  // const { applicantEmail, otp } = payload;
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('registration-token') || payload?.token}`,
    };
    return await axios.post(`${API_URL}/applicant-registration/create`, payload, { headers });
  } catch (err) {
    throw err.response?.data || err;
  }
};

// api to get details in admin side of applicant registration
export const getApplicantDetailsById = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token') || payload?.token}`,
    organisationid: ls.get('orgId') || payload.orgId,
  };
  try {
    return await axios.get(`${API_URL}/admin/apprenticeship-program/applicant-details/${payload?.id}`, { headers });
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const approveApplicantDynamicField = async (payload) => {
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('token') || payload?.token}`,
      organisationid: ls.get('orgId') || payload.orgId,
    };
    return await axios.post(`${API_URL}/admin/apprenticeship-program/apprenticeship-registration-flow/approve`, payload, { headers });
  } catch (err) {
    throw err.response?.data || err;
  }
};
